import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import FMPHeadline from '../../components/ui/FMPHeadline';
import BulkCustomersContainer from '../../containers/logistics/BulkCustomers';
import EnhancedTableHead from '../../components/EnhancedTableHead';
import { formatPrimaryContact, isFiltered, sortTable } from '../../libs/utility';
import CheckIcon from "@material-ui/icons/Check";

import {getSharedStyles} from "../../themes";
const styles = (theme) => ({
	...getSharedStyles(theme),
	button: {
		verticalAlign : 'middle',
		padding : '8px 10px',
	},
	stats : {
		padding : '20px 10px 20px 10px',
		borderBottom : '1px solid #ddd',
		marginBottom : 10,
	},
	statGroup : {
		padding : '5px 5px 10px 5px',
		borderBottom : '1px solid #eee',
		marginBottom : 10,
	},
	available : {
		fontWeight : 900,
	}
});

//const columnStyle = { whiteSpace : 'nowrap' };
const columnData = [
	{ id: 'name',  label: 'Name',  padding : 'checkbox' },
	{ id: 'primaryContact', label: 'Primary Contact', padding : 'checkbox' },
	{ id: 'terminalDisplay',  numeric: false,  padding: 'checkbox',  label: 'Terminals' },
	{ id: 'invoiceEmails', numeric: false, label: 'Invoice Emails', padding : 'checkbox' },
	{ id: 'formulaDisplay', numeric: false, label: 'Formula', padding : 'checkbox' },
	{ id: 'isQuickbooksLinked', numeric: false, label: 'QB Link', padding : 'checkbox' },
	{ id: 'edit', numeric: false,  label: 'Edit' }
];

class BulkCustomers extends Component {
	constructor(props){
		super(props);
		this.state = {
			order: 'desc',
			orderBy: 'name',
			search : '',
		};
	}

	componentDidMount () {
		if (!this.props.bulkCustomers.length) {
			this.props.searchBulkCustomers();
		}
	}

	handleSearch = (event) => {
		this.setState({ search : event.target.value });
	};

	handleRequestSort = (orderBy) => {
		let order = 'desc';
		if (this.state.orderBy === orderBy && this.state.order === 'desc') {
			order = 'asc';
		}
		this.setState({ order, orderBy });
	};

	handleEdit = (bulkCustomerId) => {
		this.props.history.push(`/logistics/bulkCustomer/update/${bulkCustomerId}`);
	};

	render() {
		const {
			classes,
			bulkCustomers,
			canMakeUpdates,
			terminalMap,
			bulkFormulaMap,
		} = this.props;

		const { order, orderBy, search} = this.state;

		if (!bulkCustomers) {
			return (<div>Loading the bulk customers...</div>);
		}
		let rows = bulkCustomers.reduce((result, bulkCustomer) => {
			const {
				bulkCustomerId,
				name,
				offloadTerminals,
				deliveryEmails,
				contacts,
				invoiceEmails,
				invoiceQuickbooksCustomerId,
				bulkFormulaId,
				requirePricingPerInvoice,
			} = bulkCustomer;

			const primaryContact = formatPrimaryContact(_.first(contacts));

			let deliveryEmailDisplay;
			if (_.isEmpty(deliveryEmails)) {
				deliveryEmailDisplay = '-';
			} else {
				deliveryEmailDisplay = deliveryEmails.map((deliveryEmail, i) => {
					return (<div key={i}>{deliveryEmail}</div>);
				});
			}

			let terminalDisplay = offloadTerminals.map((offloadTerminal, i) => {
				const { terminalId } = offloadTerminal;
				const terminal = terminalMap[terminalId];
				const display = (terminal)
					? terminal.name
					: 'Missing Terminal';
				return (<div key={i} >{display}</div>);
			});

			let invoiceEmailList = (<div><i style={{color:"#999"}}>None</i></div>);
			if (!_.isEmpty(invoiceEmails)) {
				invoiceEmailList = (<div>
					{invoiceEmails.map(email => { return (<div key={email}>{email}</div>);}) }
				</div>);
			}

			const isQuickbooksLinked = (invoiceQuickbooksCustomerId)
				? <CheckIcon />
				: <div />;

			let formulaDisplay;
			if (requirePricingPerInvoice) {
				formulaDisplay = '(per invoice)';
			} else if (bulkFormulaId) {
				const bulkFormula = bulkFormulaMap[bulkFormulaId] ||
					{ display : `Missing ${bulkFormulaId}`};

				formulaDisplay = bulkFormula.display;
			} else {
				formulaDisplay = '!! EMPTY !!';
			}

			const row = {
				bulkCustomerId,
				name,
				primaryContact,
				deliveryEmailDisplay,
				terminalDisplay,
				invoiceEmailList,
				isQuickbooksLinked,
				formulaDisplay,
			};

			if (isFiltered({search, data : row, fields : ['name',]})) {
				return result;
			}
			result.push(row);
			return result;
		}, []);
		rows = sortTable({ data : rows, order, orderBy});

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<FMPHeadline
						label="Bulk Customers"
						value={this.state.search}
						onChange={this.handleSearch}
						url="/logistics/bulkCustomer/add"
						buttonText="ADD BULK CUSTOMER"
						canMakeUpdates={canMakeUpdates}
					/>

					<Paper className={classes.paper}>
						<Table stickyHeader size="small" className={classes.table}>
							<EnhancedTableHead
								columnData={columnData}
								order={order}
								orderBy={orderBy}
								onRequestSort={this.handleRequestSort}
							/>
							<TableBody>
								{rows.map(row => {
									return (
										<TableRow
											hover
											className={classes.row}
											key={row.bulkCustomerId}
										>
											<TableCell>{row.name}</TableCell>
											<TableCell>{row.primaryContact}</TableCell>
											<TableCell>{row.terminalDisplay}</TableCell>
											<TableCell>{row.invoiceEmailList}</TableCell>
											<TableCell>{row.formulaDisplay}</TableCell>
											<TableCell>{row.isQuickbooksLinked}</TableCell>

											{canMakeUpdates &&
											<TableCell style={{whiteSpace:'nowrap'}}>
												<Button
													className={classes.button}
													onClick={() => this.handleEdit(row.bulkCustomerId)}
												>
													Edit
												</Button>
											</TableCell>
											}

										</TableRow>
									);
								})}
							</TableBody>
						</Table>
					</Paper>
				</Grid>
			</Grid>
		);
	}
}

BulkCustomers.propTypes = {
	classes: PropTypes.object.isRequired,
	searchBulkCustomers: PropTypes.func.isRequired,
	bulkCustomers : PropTypes.array,

	showErrors : PropTypes.func.isRequired,

	supplierMap : PropTypes.object,
	carrierMap : PropTypes.object,
	terminalMap : PropTypes.object,
	bulkFormulaMap : PropTypes.object,

	order: PropTypes.string,
	orderBy: PropTypes.string,
	history : PropTypes.object,

	canMakeUpdates : PropTypes.bool,
};

export default _.flow([
	withStyles(styles),
	BulkCustomersContainer
])(BulkCustomers);